export const promiseTimeout = (promise, ms = 500) => new Promise(((resolve, reject) => {
    const timer = setTimeout(() => {
        reject(new Error(`Promise timeout after ${ms}ms`));
    }, ms);

    promise
        .then((res) => {
            clearTimeout(timer);
            resolve(res);
        })
        .catch((err) => {
            clearTimeout(timer);
            reject(err);
        });
}));
